import { useState, useCallback } from "react";
import { getErrorMessage } from "shared/api/getErrorMessage";

export function useHttpRequest(api) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const sendRequest = useCallback(async (payload) => {
    setLoading(true);
    setError(null);

    try {
      const response = await api(payload);

      if (response?.ok === false) {
        throw response;
      }

      return response;
    } catch (e) {
      const message = getErrorMessage(e);
      setError(message);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);
  return { sendRequest, loading, error, clearError };
}
